module.exports = __webpack_public_path__ + "images/category_lp/bike/assessment_achievements/3_26233e279aa89da8c4f84f2a0b980f63.jpg";